import { Grid } from '@mui/material';
import Card from "@mui/material/Card";
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
    VerificationAgencyClientService
} from "../../../../Component/Api/VerificationAgency/VerificationAgencyClient/VerificationAgencyClientService";
import { SmallLoading } from "../../../../Component/Common/Components/Loading/IntermediateLoading";
import { MDBox } from "../../../../Component/Common/Components/MDBox";
import { MDTypography } from "../../../../Component/Common/Components/MDTypography";
import { FeedbackExternalDto } from "../../../../Component/Model/Dto/VerificationAgency/VerificationAgencyClient";
import { FeedbackCaptureExternalPage } from "./FeedbackCaptureExternalPage";
import { useRecoilState } from 'recoil';
import { VerificationCompanyAtom } from '../../../../State/VerificationCompany.Atom';
import { ClientHeaderBanner } from '../../../../Component/Common/Components/ServiceApplication/ClientHeaderBanner';
import { ExpiredLinkScreen } from '../../../../Component/Common/Components/ExpiredLinkScreen/ExpiredLinkScreen';
import { ClientFooterBanner } from '../../../../Component/Common/Components/Footer/ClientFooterBanner';
import { FeedbackSubmittedScreen } from './FeedbackSubmittedScreen';

export const FeedbackPageForExternalUse = () => {
    const [isLoading, setIsLoading] = React.useState<boolean>(true);
    const [isTokenAuthorised, setIsTokenAuthorised] = React.useState<boolean>(false);
    const [isSubmitted, setIsSubmitted] = React.useState<boolean>(false);
    const [externalFeedback, setExternalFeedback] = React.useState<FeedbackExternalDto>();
    const [verificationAgencyBanner, setVerificationAgencyBanner] = React.useState<string>('');
    const [company, setCompany] = useRecoilState(VerificationCompanyAtom);
    const token = useParams<any>();

    const handleSubmit = (i: boolean) => {
        setIsSubmitted(i);
    }

    const TokenAuthorised = async () => {
        const response = await VerificationAgencyClientService.IsTokenActive(token.token)
        setExternalFeedback(response.data);
        setIsTokenAuthorised(response.data.isTokenActive);
        setIsLoading(false);
    }

    const getCompanyDetails = async () => {
        try {
            const response = await VerificationAgencyClientService.GetCompanyDetailsForExternalFeedback(token.token.toString());
            setCompany({ ...company, ...response.data, applicationId: 0, company: response.data.companyName, verificationAgency: response.data.verificationAgencyName });
            setVerificationAgencyBanner(response.data.verificationAgencyBanner);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        TokenAuthorised();
    }, []);

    useEffect(() => {
        if (isTokenAuthorised && token.token.toString() !== null) {
            getCompanyDetails();
        }
    }, [isTokenAuthorised, token]);

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh'
        }}>
            {verificationAgencyBanner
                && <ClientHeaderBanner banner={verificationAgencyBanner} />
            }

            {!isTokenAuthorised && !isLoading && (
                <ExpiredLinkScreen subText1='Sorry, your feedback survey link has expired.'
                    subText2='Please contact your Verification Agency to send you a new link.' />
            )}

            <div style={{
                flexGrow: 1
            }}>
                <Grid container justifyContent="center">
                    <Grid item xs={11} mt={3}>
                        {isLoading && <SmallLoading />}

                        {!isSubmitted && !isLoading && isTokenAuthorised && (
                            <FeedbackCaptureExternalPage
                                setSubmitted={handleSubmit}
                                token={token.token}
                                companyName={externalFeedback?.companyName}
                                vaClientId={externalFeedback?.vaClientId} />
                        )}

                        {isSubmitted && !isLoading && (
                            <FeedbackSubmittedScreen />
                        )}
                    </Grid>
                </Grid>
            </div>

            <ClientFooterBanner />
        </div>
    )
}


